import { render, staticRenderFns } from "./integral-exchange.vue?vue&type=template&id=1380572a&scoped=true&"
import script from "./integral-exchange.vue?vue&type=script&lang=js&"
export * from "./integral-exchange.vue?vue&type=script&lang=js&"
import style0 from "./integral-exchange.vue?vue&type=style&index=0&id=1380572a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380572a",
  null
  
)

export default component.exports